import cls from "./liked.module.scss";
import { IShop, Product } from "interfaces";
import dynamic from "next/dynamic";
import { useEffect } from "react";

const LikedProducts = dynamic(() => import("./likedProducts"));
const LikedShops = dynamic(() => import("./likedShops"));

type Props = {
  type: "shop" | "product";
  data: Product[] | IShop[];
  isLoading?: boolean;
  hasNextPage?: boolean;
  isFetchingNextPage?: boolean;
  fetchingNextPage?: () => void;
};

export default function LikedContainer({
  type,
  data,
  isLoading = false,
  hasNextPage = false,
  isFetchingNextPage = false,
  fetchingNextPage,
}: Props) {
  const renderView = () => {
    switch (type) {
      case "shop":
        return (
          <LikedShops
            // @ts-ignore
            data={data}
            isLoading={isLoading}
            isFetchingNextPage={isFetchingNextPage}
            hasNextPage={hasNextPage}
            fetchingNextPage={fetchingNextPage}
          />
        );
      case "product":
        return (
          <LikedProducts
            // @ts-ignore
            data={data}
            isLoading={isLoading}
            isFetchingNextPage={isFetchingNextPage}
            hasNextPage={hasNextPage}
            fetchingNextPage={fetchingNextPage}
          />
        );
      default:
        return <span />;
    }
  };
  return <section className={cls.container}>{renderView()}</section>;
}
